import skynetAPI from 'api';
import accountsJwtService, { jwtManager } from 'app/services/jwtService';

import { API_GET_SSO_TOKEN } from 'constants/api';
import { getCompanyId } from 'utils/domain';
import { checkIsAppLoadedInIframe } from 'utils/iframe';

import { setMasterDataAction } from './master.actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const RESET_LOGIN_ERROR = 'RESET_LOGIN_ERROR';

export const submitLoginAction = params => dispatch => {
  dispatch({ type: LOGIN_LOADING });

  // We assume that if app loaded in iframe it is rendered in hubspot
  const isHubspotSession = checkIsAppLoadedInIframe();

  return accountsJwtService
    .signInWithEmailAndPassword({ ...params, isHubspotSession })
    .then(master => {
      dispatch(setMasterDataAction(master));
      dispatch({ type: LOGIN_SUCCESS });

      return master;
    })
    .catch(error => {
      dispatch({
        type: LOGIN_ERROR,
        payload: error || 'Internal error',
      });

      return error;
    });
};

export const ssoSignInAction =
  ({ ssoTokenKey, isHubspotSession }) =>
  dispatch => {
    return skynetAPI
      .get(API_GET_SSO_TOKEN, {
        params: { ssoTokenKey, isHubspotSession },
        headers: { companyId: getCompanyId() },
      })
      .then(({ data: jwtToken }) => {
        jwtManager.setToken(jwtToken);

        return accountsJwtService.signInWithToken().then(master => {
          dispatch(setMasterDataAction(master));

          return master;
        });
      });
  };

export const autoLoginAction = (token, refreshToken, refreshTokenExpiresAt) => dispatch =>
  accountsJwtService
    .signInWithAccessToken(token, refreshToken, refreshTokenExpiresAt)
    .then(master => {
      dispatch(setMasterDataAction(master));

      return master;
    })
    .catch(error => Promise.reject(error));

export const resetLoginErrorAction = () => dispatch => {
  dispatch({
    type: RESET_LOGIN_ERROR,
  });
};
